import React from "react";
import { Icon } from "@iconify/react";

const ClaimsIcon = () => (
  <Icon icon="lucide:shield-check" width={18} height={18} />
);

export default ClaimsIcon;
